import { NavLink, Outlet } from 'react-router-dom';
import type { AuthUser } from '../domain/types';
import { api } from '../api/http';
import { Icons } from '../ui';
import { Button } from '../ui';

const NAV = [
  { to: '/', label: 'Tableau de bord', end: true },
  { to: '/eventsub', label: 'EventSub' },
  { to: '/activity', label: 'Activité' },
];

export function Shell({ user }: { user?: AuthUser }): JSX.Element {
  return (
    <div className="tbm-app" data-density="comfortable">
      <aside className="tbm-rail">
        <div className="tbm-rail__brand">Twitch Bots</div>
        <nav className="tbm-rail__nav">
          {NAV.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={({ isActive }) => `tbm-rail__link${isActive ? ' is-active' : ''}`}>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div style={{ marginTop: 'auto', display: 'grid', gap: 'var(--tbm-space-2)' }}>
          <span data-testid="auth-user" className="muted">{user?.name ?? user?.email ?? user?.sub}</span>
          <Button
            variant="ghost"
            size="sm"
            onClick={async () => {
              await api.logout();
              window.location.href = api.loginUrl;
            }}
          >
            <Icons.logout /> Déconnexion
          </Button>
        </div>
      </aside>
      <main className="tbm-main">
        <div className="tbm-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
